// client/src/services/billingReceiptService.js
import api from './api';

const billingReceiptService = {
  getBillingReceipts: async () => {
    const response = await api.get('/billing-receipts');
    return response.data;
  },
  
  getBillingReceipt: async (id) => {
    const response = await api.get(`/billing-receipts/${id}`);
    return response.data;
  },
  
  createBillingReceipt: async (formData) => {
    const response = await api.post('/billing-receipts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  
  updateBillingReceiptStatus: async (id, statusData) => {
    const response = await api.put(`/billing-receipts/${id}`, statusData);
    return response.data;
  },
  
  // New approval methods
  approveReceipt: async (id, data) => {
    const response = await api.put(`/billing-receipts/${id}/approve`, data);
    return response.data;
  },
  
  rejectReceipt: async (id, data) => {
    const response = await api.put(`/billing-receipts/${id}/reject`, data);
    return response.data;
  },
  
  deleteBillingReceipt: async (id) => {
    const response = await api.delete(`/billing-receipts/${id}`);
    return response.data;
  },
  
  // Download methods with summarized option
  downloadReceiptExcel: async (id, summarized = false) => {
    const url = `/billing-receipts/${id}/download${summarized ? '?summarized=true' : ''}`;
    // Trigger download by creating a temporary link
    try {
      const response = await api.get(url, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `receipt_${id}_${summarized ? 'summarized' : 'detailed'}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  },
  
  downloadReceiptDistributionExcel: async (id, summarized = false) => {
    const url = `/billing-receipts/${id}/download-distribution${summarized ? '?summarized=true' : ''}`;
    // Trigger download by creating a temporary link
    try {
      const response = await api.get(url, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `distribution_${id}_${summarized ? 'summarized' : 'detailed'}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  }
};

export default billingReceiptService;